import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { PoBreadcrumb, PoDialogService, PoNotificationService, PoPageSlideComponent, PoTableColumn } from '@po-ui/ng-components';
import { ProcessoCadastro, defaultProcessoCadastro } from 'src/app/administrativo/interface/processo-cadastro';
import { ProcessoPreCadastroProduto, ProcessoPreCadastroProdutoDto, defaultProcessoPreCadastroProduto } from 'src/app/administrativo/interface/processo-pre-cadastro-produto';
import { ProcessoCadastroService } from 'src/app/administrativo/service/processo-cadastro';
import { AuthService } from 'src/app/service/auth.service';
import { BaseService } from 'src/app/service/base-service';
import { ProdutoService } from 'src/app/service/produto-service';
import { UtilService } from 'src/app/service/util';
import { UtilArquivo } from 'src/app/util/arquivo/util-arquivo.component';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-revisao-cadastro-produto-crud',
  templateUrl: './revisao-cadastro-produto-crud.component.html',
  styleUrls: ['./revisao-cadastro-produto-crud.component.css']
})
export class RevisaoCadastroProdutoCrudComponent implements OnInit {

  preProduto: ProcessoPreCadastroProduto = defaultProcessoPreCadastroProduto();
  processoCadastro: ProcessoCadastro = defaultProcessoCadastro();

  bloqueiaDadosSolicitante: boolean = true;

  usuarioLogado: string = '';
  fileChave: string = '';
  fileAlias: string = 'IMGPRODUTO';

  usuarioSolicitante: boolean = false;
  usuarioCompras: boolean = false;
  usuarioControladoria: boolean = false;
  usuarioEngenharia: boolean = false;

  liberaAvancarProcesso: boolean = true;

  tabelaHistorico: Array<any> = [];

  historico: string = '';
  urgente: string = 'N';

  urlApiProtheus: string = environment.urlApiProtheus;

  breadcrumb: PoBreadcrumb = {
    items: [
      {label: 'Home', action: this.goHome.bind(this)},
      {label: 'Lista', action: this.goLista.bind(this)},
      {label: 'Revisão Cadastro Produto'},
    ],
  };

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private poNotificationService: PoNotificationService,
    private poDialogService: PoDialogService,
    private utilService: UtilService,
    private baseService: BaseService,
    private authService: AuthService,
    private processoCadastroService: ProcessoCadastroService,
    private produtoService: ProdutoService,

  ) { }

  @ViewChild('formPrincipal', { static: true }) formPrincipal!: NgForm;
  @ViewChild('utilArquivo', { static: true }) utilArquivo!: UtilArquivo;
  @ViewChild('anexoPageSlide', { static: true }) anexoPageSlide!: PoPageSlideComponent;

  ngOnInit(): void {

    this.usuarioLogado = localStorage.getItem('CUSRID') || '';
    this.fileChave = this.utilService.getUniqueId(4);

    this.activatedRoute.params.subscribe({
      next : (params) => {
        if ('NPROCESSOCODIGO' in params && 'NCODIGO' in params) {
          this.loadDados(params.NPROCESSOCODIGO, params.NCODIGO)
        } else {
          this.bloqueiaDadosSolicitante = false;
        }
      },error: () => {
        this.poNotificationService.warning('Dados de acesso inválidos!');
        this.goLista();
      }
    })

  }

  loadDados(NPROCESSOCODIGO: number, NCODIGO: number):void{

    this.processoCadastroService.getProcCadastro(NPROCESSOCODIGO).subscribe({
      next: (ret) => {
        this.processoCadastro = ret;

        this.urgente = ret.CURGENTE;

        this.usuarioSolicitante = (this.processoCadastro.CCODIGOUSUARIOPROTHEUS === this.usuarioLogado);

        this.authService.validaPrivilegio(['PORTAL_ADMINISTRADOR', 'PO_PRECAD_COMPRAS']).then((temPermissao) => {
          this.usuarioCompras = temPermissao;
        });

        this.authService.validaPrivilegio(['PORTAL_ADMINISTRADOR', 'PO_PRECAD_CONTROLADORIA']).then((temPermissao) => {
          this.usuarioControladoria = temPermissao;
        });

        this.authService.validaPrivilegio(['PORTAL_ADMINISTRADOR', 'PO_PRECAD_ENGENHARIA']).then((temPermissao) => {
          this.usuarioEngenharia = temPermissao;
          this.liberaTela();
        });

      }
      ,error: () => {
        this.goLista();
      }
    })

    this.processoCadastroService.getProcCadastroPreProduto(NCODIGO).subscribe({
      next: (ret) => {

        this.preProduto = ret;
        this.fileChave = this.preProduto.CB1COD;

      }
      ,error: () => {
        this.goLista();
      }
    })

    this.processoCadastroService.getProcCadastroHistoricoLista(NPROCESSOCODIGO).subscribe({
      next: (historico) => {
        this.tabelaHistorico = historico.items;
      }
    })

  }

  liberaTela():void{
    if (['7'].includes(this.processoCadastro.CSTATUS) && this.usuarioEngenharia){
      this.bloqueiaDadosSolicitante = false;
    } else if (['3'].includes(this.processoCadastro.CSTATUS) && this.usuarioCompras){
      this.bloqueiaDadosSolicitante = false;
    } else if (['5'].includes(this.processoCadastro.CSTATUS) && this.usuarioControladoria){
      this.bloqueiaDadosSolicitante = false;
    } else {
      this.liberaAvancarProcesso = false;
    }
  }

  produtoSelecionado(codigoProduto: string):void{
    this.produtoService.getProduto(codigoProduto).subscribe({
      next: (produto) =>{
        this.preProduto.CB1DESC = produto.CB1DESC;
        this.preProduto.CB1MRP = produto.CB1MRP;
        this.preProduto.CB1UM = produto.CB1UM;
        this.preProduto.NB1EMIN = produto.NB1EMIN;
        this.preProduto.NB1EMAX = produto.NB1EMAX;
        this.fileChave = produto.CB1COD;
      }
    })
  }


  gravarDados(decisao: string):void{

    const dados: ProcessoPreCadastroProdutoDto = {
      CURGENTE: this.urgente,
      PRODUTO: this.preProduto,
      CHISTORICO: this.historico,
      CDECISAO: decisao,
      CARQUIVOSCHAVE: this.fileChave,
    };

    this.processoCadastroService.postProcCadastroRevisaoProduto(dados).subscribe({
      next: (ret) => {
        this.goLista();
      }
    })

  }

  confirmarTela():void{

    if (this.formPrincipal.valid){
      let texto = '';
      if (this.processoCadastro.NCODIGO <= 0){
        texto = 'Deseja incluir a solicitação de alteração no cadastro de produto?'
      } else {
        texto = 'Deseja aprovar a solicitação de alteração no cadastro de produto?'
      }

      this.poDialogService.confirm({
        title: 'Avançar processo',
        message: texto,
        confirm: () =>{
          this.gravarDados('A');
        }
      })
    } else {
      this.utilService.showErrosFomulario(this.formPrincipal,document);
    }

  }

  cancelarRecusarTela():void{
    if (this.processoCadastro.CSTATUS){
      if (this.historico){
        this.poDialogService.confirm({
          title: 'Recusar processo',
          message: 'Deseja Recusar a alteração no cadastro deste Produto?',
          confirm: () =>{
            this.gravarDados('R');
          }
        })
      } else {
        this.poNotificationService.warning({
          message: 'Informe uma observação para poder recusar a alteração no cadastro do produto.',
          duration: 5000
        })
      }
    } else {
      this.poDialogService.confirm({
        title: 'Cancelar Solicitação',
        message: 'Deseja sair da tela e cancelar a solicitação de alteração no cadastro de produto?',
        confirm: () =>{
          this.goLista();
        }
      })
    }
  }

  goLista(): void {
    this.router.navigateByUrl('administrativo/revisao-cadastro/produto/lista');
  }

  goHome(): void {
    this.router.navigateByUrl('');
  }

  //##############################################
  // arquivos
  //##############################################
  arquivosLoadDados(): void {
    this.utilArquivo.empresa = '01',
    this.utilArquivo.filial  = '01',
    this.utilArquivo.habilitaUpload = false;
    this.utilArquivo.podeExcluir = false;
    this.utilArquivo.arquivosLoadDados(this.fileAlias, this.fileChave);
    this.anexoPageSlide.open();
  }

  public readonly tabelaHistoricoColunas: Array<PoTableColumn> = [
    {property: 'CCODIGOUSUARIOPROTHEUS_NOME', label: 'Usuário'   , width: '15%', visible: true},
    {property: 'DDATA'                      , label: 'Data'      , width: '10%', visible: true, type: 'date', format: 'dd/MM/Y'},
    {property: 'CHORA'                      , label: 'Hora'      , width: '10%', visible: true},
    {property: 'CSTATUS' , width: '10%' , label: 'Status' , visible: true, type: 'label' ,
      labels: [
        { value: '7', color: 'color-03', label: 'Engenharia'},
        { value: '0', color: 'color-04', label: 'Engenharia Negado'},
        { value: '3', color: 'color-05', label: 'Compras'},
        { value: '6', color: 'color-06', label: 'Compras Negado'},
        { value: '5', color: 'color-07', label: 'Controladoria'},
        { value: '8', color: 'color-08', label: 'Controladoria Negado'},
        { value: '9', color: 'color-10', label: 'Finalizado'},
        { value: 'A', color: 'color-12', label: 'Cancelado'},
      ]
    },
    {property: 'COBSERVACAO'                , label: 'Observação', width: '55%', visible: true},
  ]

}

